module.exports = __webpack_public_path__ + "static/media/industrialBuilding-geotiller.17ca6cad.svg";